import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { OrchestratorInstance } from 'src/app/services/data/models/jobs/orchestrator-instance';
import { FSSnap } from 'src/app/utils/firestore/fs-snap';

const pageLimit = 10;

@Component({
    selector: 'app-orchestrators',
    templateUrl: './orchestrators.component.html',
    styleUrls: ['./orchestrators.component.scss'],
})
export class OrchestratorsComponent implements OnInit {
    loading = true;
    /**
     * Undefined means data is loading.
     */
    orchestrators: (FSSnap<OrchestratorInstance> | undefined)[] = [];

    constructor(private data: DataService) {}
    async ngOnInit(): Promise<void> {
        await this.loadMoreData();
    }

    async loadMoreData(): Promise<void> {
        this.loading = true;
        var newDataPromise = this.data.getBIOrchestratorsByUpdateTime(
            this.orchestrators.length === 0
                ? undefined
                : this.orchestrators[this.orchestrators.length - 1]!.snap,
            pageLimit
        );
        this.orchestrators.push(...Array(pageLimit).fill(undefined));
        var newData = await newDataPromise;
        this.orchestrators.splice(
            this.orchestrators.length - pageLimit,
            pageLimit
        );
        this.orchestrators.push(...newData);
        this.loading = false;
    }

    copyFirestoreLink(o: FSSnap<any>): void {
        navigator.clipboard.writeText(
            `https://console.firebase.google.com/project/${
                o.snap.ref.firestore.app.options.projectId
            }/firestore/data/${encodeURIComponent(o.snap.ref.path)}`
        );
    }
}
